import React from "react";
import "../Style/tuitorialLibrary.css"; // Create this CSS file if needed, similar to privacyPolicy.css

const TuitorialLibraryBanner = () => {
  return (
   <div className=" flex justify-center items-center text-white z-50 contact-banner">
      <h1 className=" text-white text-[32px] lg:text-[40px] mt-16 font-semibold leading-[97px]">
        Tutorial Video{" "}
      </h1>
    </div>
  );
};

export default TuitorialLibraryBanner;
